import { SignedUrlForImage } from "components"
import { Image } from "antd-v5"
import { addLeadingZeros } from "config/utils"
import tickMark from "images/tickMark.png"
import { IncidentInterface } from "@type/workMonitor.types"
import { Pill } from "components"

interface Props {
	incidents: IncidentInterface[]
}

const IncidentsTable: React.FC<Props> = ({ incidents }) => {
	if (!incidents.length) return null

	const getActions = (incident: IncidentInterface) => {
		const actions = []

		if (incident.isPoliceRequested) actions.push({ label: "Police Requested", key: "police" })
		if (incident.actionTaken) actions.push({ label: "Action Taken", key: "action" })
		if (incident.controlInformed) actions.push({ label: "Control Informed", key: "control" })

		return actions
	}

	return (
		<div className="w-full space-y-5">
			<div className="flex w-full justify-between bg-[#B2DDFF] py-3 px-6 text-sm">
				<div className="font-medium">INCIDENT</div>
				<div className="flex space-x-10">
					<div className="flex space-x-3">
						<span className="font-medium">TOTAL INCIDENTS:</span>
						<span>{addLeadingZeros(incidents.length, 2)}</span>
					</div>
				</div>
			</div>
			<table className="ml-[0px] w-full table-auto text-sm">
				<tbody>
					{incidents.map(incident => {
						const { _id, details, images, reportingOfficer, incident: incidentTitle } = incident
						return (
							<div key={`incident-${_id}`}>
								<tr className=" border-0.125 border-[#667085]  ">
									<td className="w-1/4   py-3 pl-3 text-gray-500">INICIDENT TITLE:</td>
									<td className="w-3/4 border-0.125 border-[#667085]  py-3 pl-3">{incidentTitle}</td>
								</tr>
								<tr>
									<td className="w-1/4 border-0.125 border-[#667085]  py-3 pl-3 text-gray-500">
										DETAILS:
									</td>
									<td className="w-3/4 border-0.125 border-[#667085]  py-3 pl-3">{details}</td>
								</tr>
								<tr>
									<td className="w-[20%] border-0.125 border-[#667085]  py-3 pl-3 align-middle text-gray-500">
										IMAGES:
									</td>
									<td className="w-[80%] border-0.125 border-[#667085] py-3 pl-3">
										<Image.PreviewGroup>
											<div className="flex flex-wrap">
												{images?.map((imgSrc, index) => (
													<SignedUrlForImage path={imgSrc} key={index}>
														{(signedUrl: string) => (
															<div className="p-2">
																<img
																	src={signedUrl}
																	alt={`Evidence ${index + 1}`}
																	className="h-[122px] w-[95px]"
																/>
															</div>
														)}
													</SignedUrlForImage>
												))}
											</div>
										</Image.PreviewGroup>
									</td>
								</tr>
								<tr className="border-0.125 border-[#667085]">
									<td className="w-1/4 border-0.125 border-[#667085]  py-3 pl-3 text-gray-500">
										ACTIONS:
									</td>
									<td className="flex w-3/4 space-x-2 py-3 pl-3 text-lg font-medium">
										{[...(getActions(incident) ?? [])].map(action => {
											return (
												<Pill
													key={`${incident._id}_${action.key}`}
													label={action.label}
													icon={<img src={tickMark} alt="tick" className="h-4 w-4" />}
													iconPosition="left"
													className="bg-[#ECFDF3] px-3 py-1  text-[#027A48]"
												/>
											)
										})}
									</td>
								</tr>
								<tr>
									<td colSpan={5} className="pt-20 text-md">
										<div className="flex space-x-2 text-gray-900">
											<span>SIGNATURE:</span>
											<span>________________________________</span>
										</div>
										<div className="flex space-x-3 pt-6">
											<span className=" text-gray-500">REPORTING OFFICER:</span>
											<span className=" text-gray-900">
												{reportingOfficer?.firstName
													? `${reportingOfficer.firstName} ${
															reportingOfficer.lastName ?? ""
													  }`.trim()
													: "N/A"}
											</span>
										</div>
									</td>
								</tr>
							</div>
						)
					})}
				</tbody>
			</table>
		</div>
	)
}

export default IncidentsTable
